import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () => {
  return axios.create({
    baseURL: `${config.serverUrl}api/users`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })
}

const usersApi = {
  postLink: (body) => {
    return instance().post(`/link`, body)
  },
  postCreateTag: (body) => {
    return instance().post('/tag', body)
  },
  postCreateStatus: (body) => {
    return instance().post('/status', body)
  }
}

export default usersApi



// WEBPACK FOOTER //
// ./src/api/users.js